import React from 'react';
import AOS from 'aos';
import Link, { withPrefix } from 'gatsby-link';

import './_header.scss';

class Header extends React.Component {
  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }


  render() {
    return (
      <header className="site-header">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <a className="navbar-brand" href="/">
              <img alt="FirstStep logo" src={withPrefix('/images/logos/logo.png')} />
              <span>FirstStep</span>
            </a>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto align-items-center">
                <li className="nav-item">
                  <Link className="nav-link" to="/how-to-firststep" activeClassName="active">How to FirstStep</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about" activeClassName="active">About us</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/pricing" activeClassName="active">Pricing</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/why-firststep" activeClassName="active">Why FirstStep</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/white-labelling" activeClassName="active">White Labelling</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/faq" activeClassName="active">FAQs</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/press" activeClassName="active">Press</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js